import styled from 'styled-components';

export const GuestListTableContainer= styled.div
.attrs(() => ({
  className: 'white mt-25',
}))`
    border-radius: 10px;
    background: #FFF;
    width:100%;
    padding:29px 28px;
`;


